import React from "react";
import { useTranslation } from "react-i18next";

import {
  StyledMainContainer,
  StyledImageContainer,
  StyledTitle,
  StyledDescription,
} from "./CaseStudiesMainStyle";
const CaseStudiesMain = ({ title, description, image }) => {
  const { t } = useTranslation();
  return (
    <StyledMainContainer>
      <StyledTitle>{t(title)}</StyledTitle>
      <StyledDescription>{t(description)}</StyledDescription>
      <StyledImageContainer>{image}</StyledImageContainer>
    </StyledMainContainer>
  );
};

export default CaseStudiesMain;
